import httpClient from 'src/common/axios/config'
import { GetWalletsModel } from './models'

interface GetWalletsParams {
  userId: string
}

export const fetchWallets = (params: GetWalletsParams) =>
  httpClient.get<GetWalletsModel[]>('/wallets/admin', { params })
